import {createContext} from 'react'

const FindReplaceContext = createContext({
  show: false,
  setShow: () => {}
})

export default FindReplaceContext
